"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function CommonLayout(_ref) {
  var title = _ref.title,
    desc = _ref.desc,
    customArea = _ref.customArea,
    className = _ref.className,
    style = _ref.style,
    titleClass = _ref.titleClass,
    descClass = _ref.descClass,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("".concat(_indexModule["default"].commonLayout_pc), className),
    style: style,
    onClick: onClick
  }, title ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("".concat(_indexModule["default"].title), titleClass)
  }, title) : null, desc ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("".concat(_indexModule["default"].desc), descClass)
  }, desc) : null, customArea ? customArea : null);
}
var _default = exports["default"] = CommonLayout;